import fetch from 'isomorphic-fetch';
import { newNotification } from "./notifications";
import { /*API_URL, */API2_URL, USER_EDIT, USERS_SHOW, USERS_FAIL, USERS_REQUEST, USER_ROLE, USER_AGENCIES, USER_COMPLETE, USER_CLEAR/*, USER_SET_SEARCH */} from "../store/config";
import _ from "lodash";
import { history } from "../store/store";
import FileSaver from 'file-saver';
import { sessionService } from 'redux-react-session';

export const usersList = (page = 1,filters={}) => {

	return dispatch => {
		dispatch(usersRequest());

		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});

				return fetch(`${API2_URL}/users?include[0]=roles&include[1]=status&page=${page}${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(usersListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const usersFind = (value) => {

	return dispatch => {
		dispatch(usersRequest());

		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/users?q=${value}&per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(usersListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const fetchUsersList = () => (dispatch) => {
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(usersRequest());
			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/users?per_page=all`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(usersListData(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

export const usersExport = (filters={}) => {
	//const token = sessionStorage.getItem('etrans_user');

	return dispatch => {
		dispatch(usersRequest());
		return dispatch(sessionService.loadUser)
			.then((sess) => {
				const options = {headers: {
						'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				let params = '';
				_.mapKeys(filters, (value, key) => {
					if(value){
						params = `${params}&${key}=${value}`;
					}
				});
				let fileName= undefined;

				return fetch(`${API2_URL}/users?include[0]=roles&include[1]=status&export=1${params}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							let header = result.headers.get('Content-Disposition','attachment')
							fileName = header.match(/filename="(.+)"/)[1];
							return result.blob();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						blob => {
							//let today = new Date();
							//let date = today.getFullYear() + ((today.getMonth() + 1) <10 ? `0${today.getMonth() + 1}`:today.getMonth() + 1) + (today.getDate()<10 ? `0${today.getDate()}`:today.getDate()) + today.getHours() + today.getMinutes() + today.getSeconds();
							//FileSaver.saveAs(blob,`reporte_usuarios_${date}.xls`);
							FileSaver.saveAs(blob,fileName);
							dispatch(userComplete());
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

/*Fetch User Edit*/
export const fetchUser = (id) => (dispatch) => {
	dispatch(usersRequest());
	dispatch(userClear());
	return dispatch(userDetail(id))
		.then((user) => {
			if(!_.isEmpty(user.payload)){
				if(user.payload.role_id){
					return dispatch(userAgencies(id))
						.then((agencies) => {
							if(!_.isEmpty(agencies.payload)){
								return dispatch(userComplete());
							}else {
								return dispatch(usersFail(agencies.error));
							}
						})
				}else {
					return dispatch(userComplete());
				}
			}else {
				return dispatch(usersFail(user.error));
			}
		})
}

const userDetail = (id) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};
				return fetch(`${API2_URL}/users/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(userData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			});
	}
}

const userAgencies = (user) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/users/${user}/agencies`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(userAgenciesData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

/*User Save*/
export const userSave = (data) => (dispatch) => {
	const { agencies } = data;

	let body = new FormData();

	if(!_.isEmpty(agencies)){
		if((_.isArray(agencies) || _.isObject(agencies)) && agencies.id && agencies.state_id) {
			body.append('municipality_id', agencies.id);
		}else if(_.isObject(agencies) && agencies.id && !agencies.state_id) {
			body.append('state_id', agencies.id);
		}else if(_.isObject(agencies)) {
			console.log('is many agencies');
			_.mapKeys(agencies, (o, i) => {
				if(o === true || _.isObject(o)) {
					body.append(`states[${i}]`, i);
				}
			});
		}else{
			body = false;
		}
	}else{
		body = false;
	}

	dispatch(usersRequest());
	return dispatch(userEditSave(data))
		.then((user) => {
			if(!_.isEmpty(user.payload)){
				if(data.edit.id){
					return dispatch(userSaveRole(data, user.payload.id))
						.then((role) => {
							if(!_.isEmpty(role.payload)){
								if(body){
									return dispatch(userAgencySave(user.payload.id, body))
										.then((agency) => {
											if(!_.isEmpty(agency.payload)){
												return dispatch(userComplete());
											}else {
												return dispatch(usersFail(agency.error));
											}
										})
								}else {
									return dispatch(userComplete());
								}
							}else {
								return dispatch(usersFail(role.error));
							}
						})
				}else {
					return dispatch(userComplete());
				}
			}else {
				return dispatch(usersFail(user.error));
			}
		})
}

const userEditSave = (data) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(data.edit)
				};

				return fetch(`${API2_URL}/users${data.edit.id ? `/${data.edit.id}?_method=PUT`:''}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"¡Éxito!", content: json.message, type: "success"}));
							if(_.isEmpty(data.edit.id)){
								history.push('/usuarios/editar/'+json.data.id);
							}
							return dispatch(userData(json))
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

const userSaveRole = (data, id) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify({role_id: data.edit.role_id})
				};

				return fetch(`${API2_URL}/users/${id}/roles`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							if(_.isEmpty(data.agencies)){
								dispatch(newNotification({title:"¡Éxito!", content: json.message, type: "success"}));
								if (history.location.pathname === '/usuarios/crear'){
									history.push('/usuarios/editar/'+id);
								}
							}
							return dispatch(userRoleData(json))
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

const userAgencySave = (id, body) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: body
				};

				return fetch(`${API2_URL}/users/${id}/agencies?_method=PUT`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"¡Éxito!", content: json.message ? json.message:'Perfil de usuario actualizado correctamente', type: "success"}));
							if (history.location.pathname === '/usuarios/crear'){
								history.push('/usuarios/editar/'+id);
							}
							return dispatch(userAgenciesData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

export const userDelete = (id) => {

	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'delete'
				};

				return fetch(`${API2_URL}/users/${id}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title:"¡Éxito!", content: json.message, type: "success"}));
							dispatch(usersList());
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(usersFail(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					)
			})
	}
}

const usersRequest = () => {
	return {
		type: USERS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const usersFail = (error) => {
	return {
		type: USERS_FAIL,
		error: error,
		isFetching: false,
		timestamp: Date.now()
	}
}

const usersListData = (json) => {
	return {
		type: USERS_SHOW,
		isFetching: false,
		payload: !_.isEmpty(json.data) ? _.orderBy(json.data,['id']):json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const userData = (json) => {
	return {
		type: USER_EDIT,
		payload: json.data,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const userRoleData = (json) => {
	return {
		type: USER_ROLE,
		payload: {role_id: json.data[0].id},
		timestamp: Date.now()
	}
}

const userAgenciesData = (json) => {
	let agencies = [];let data;
	if(_.isArray(json.data)) {
		_.mapValues(json.data, (o, k) => {
			agencies[o.id] = o;
		})
		data = agencies;
	}else{
		data = json.data;
	}

	return {
		type: USER_AGENCIES,
		payload: data,
		timestamp: Date.now()
	}
}

const userComplete = () => {
	return {
		type: USER_COMPLETE,
		isFetching: false,
		timestamp: Date.now()
	}
}

const userClear = () => {
	return {
		type: USER_CLEAR,
		payload: {},
		permissions: [],
		timestamp: Date.now()
	}
}



// WEBPACK FOOTER //
// ./src/actions/users.js